export default "__VITE_ASSET__822bcc0e__"